export const strikethroughPolicies = {
  StrikethroughData: {
    keyFields: ['strikeThroughAddons'],
  },
};
